import { OcrApiResponse } from 'types/ocr'

// OCRデータからアレルゲン配列をbooleanフラグに変換
export const mapAllergensToBooleans = (allergens: string[]) => {
  return {
    egg: allergens.includes('egg') || allergens.includes('卵'),
    milk: allergens.includes('milk') || allergens.includes('乳'),
    wheat: allergens.includes('wheat') || allergens.includes('小麦'),
    shrimp: allergens.includes('shrimp') || allergens.includes('えび'),
    crub: allergens.includes('crub') || allergens.includes('かに'),
    peanuts: allergens.includes('peanuts') || allergens.includes('落花生'),
    soba: allergens.includes('soba') || allergens.includes('そば'),
    almond: allergens.includes('almond') || allergens.includes('アーモンド'),
    abalone: allergens.includes('abalone') || allergens.includes('あわび'),
    squid: allergens.includes('squid') || allergens.includes('いか'),
    ikura: allergens.includes('ikura') || allergens.includes('いくら'),
    orange: allergens.includes('orange') || allergens.includes('オレンジ'),
    cashewnuts:
      allergens.includes('cashewnuts') || allergens.includes('カシューナッツ'),
    pistachio:
      allergens.includes('pistachio') || allergens.includes('ピスタチオ'),
    kiwifruit:
      allergens.includes('kiwifruit') || allergens.includes('キウイフルーツ'),
    beef: allergens.includes('beef') || allergens.includes('牛肉'),
    walnut: allergens.includes('walnut') || allergens.includes('くるみ'),
    sesame: allergens.includes('sesame') || allergens.includes('ごま'),
    salmon: allergens.includes('salmon') || allergens.includes('さけ'),
    mackerel: allergens.includes('mackerel') || allergens.includes('さば'),
    soy: allergens.includes('soy') || allergens.includes('大豆'),
    chicken: allergens.includes('chicken') || allergens.includes('鶏肉'),
    banana: allergens.includes('banana') || allergens.includes('バナナ'),
    pork: allergens.includes('pork') || allergens.includes('豚肉'),
    macadamianuts:
      allergens.includes('macadamianuts') ||
      allergens.includes('マカダミアナッツ'),
    peach: allergens.includes('peach') || allergens.includes('もも'),
    yam: allergens.includes('yam') || allergens.includes('やまいも'),
    apple: allergens.includes('apple') || allergens.includes('りんご'),
    gelatine: allergens.includes('gelatine') || allergens.includes('ゼラチン'),
  }
}

// 遺伝子組み換えタイプの判定
export const parseGeneticallyModifiedType = (type: string) => {
  const noSelection = !type || type === ''
  const modified = type.includes('組換え') || type === 'modified'
  const noDifference = type.includes('不分別') || type === 'no_difference'

  return {
    noSelection,
    modified,
    noDifference,
  }
}

// 構成原材料情報の変換
export const mapConstituteMaterialNames = (
  constituteMaterialNames: OcrApiResponse['constituteMaterialNames'],
) => {
  return constituteMaterialNames.map((item) => {
    const genetically = parseGeneticallyModifiedType(
      item.geneticallyModifiedType,
    )
    return {
      constituteMaterialName: item.rawMaterialName,
      isGenetically: {
        noSelection: genetically.noSelection,
        modified: genetically.modified,
        noDifference: genetically.noDifference,
      },
    }
  })
}

// 添加物用途情報の変換
export const mapAdditiveUseInfos = (
  additiveUseInfos: OcrApiResponse['additiveUseInfos'],
  additiveUses: Array<{ name: string; additive_use_ref: any }>,
) => {
  return additiveUseInfos
    .filter((item) => item.use || item.substance) // 空の項目を除外
    .map((item) => {
      // OCRから返された用途名とFirestoreの用途名をマッチング
      const foundUse = additiveUses.find((use) => use.name === item.use)

      // useにはadditive_use_refのIDを設定
      let useId = ''
      if (foundUse && foundUse.additive_use_ref) {
        // @ts-ignore
        useId =
          foundUse.additive_use_ref.id ||
          foundUse.additive_use_ref._key?.path?.segments[6] ||
          ''
      }

      return {
        use: useId,
        substance: item.substance,
        disabled_material_name: false,
      }
    })
}
